module.exports = __webpack_public_path__ + "img/cgzs.a405ecd.png";